import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/expansion'

Styxie.Initializers.ExpansionDashboard = {
  index: async(props) => {
    const { default: DashboardIndex } = await import('@/vue_widgets/expansion/dashboard/index.vue')
    createVueApp(DashboardIndex, { props, sidebar })
  }
}
